import { useFeatureFlagEnabled } from '@posthog/react';

/**
 * Global gate for the per-utility pothole measurements feature on web.
 *
 * While OFF, the pothole edit dialog only lets users edit a single legacy
 * measurement set and never originates the structured `utilityMeasurements`
 * prop — so web can't write a data shape older mobile clients can't read.
 * Flip to 100% once the mobile build is live in both app stores.
 *
 * Note: this is only one input to the dialog's per-record gate — a pothole that
 * already carries a structured prop shows the new UI regardless (see
 * `GeoItemDialogContent`).
 */
export const PER_UTILITY_MEASUREMENTS_FLAG = 'per-utility-measurements-enabled';

export function usePerUtilityMeasurementsEnabled(): boolean {
  return useFeatureFlagEnabled(PER_UTILITY_MEASUREMENTS_FLAG) === true;
}
